export default __webpack_public_path__ + "static/media/029-airplanes.d594cf09.png";